<!-- ORGANISM: AppBarActions.vue -->
<!-- Right-hand app-bar action area — explorer toolbar on wide screens plus account menu. -->

<script setup lang="ts">
//
// Imports
//

// Vuetify
import { useDisplay } from "vuetify/lib/composables/display.mjs";

// Components
import ExplorerToolbar from "../../../pages/validation/molecules/ExplorerToolbar.vue";
import AccountMenu from "./AccountMenu.vue";

//
// Composables
//

// Breakpoints
const { smAndDown } = useDisplay();

// App Bar
const { extensionsConfig } = useAppBar();

// Validation Page
const { explorerProps } = useValidationPage();
</script>

<template>
  <div class="d-flex align-center ga-0 mr-2">
    <ExplorerToolbar v-if="!smAndDown && extensionsConfig.component === 'ValidationExtension'" v-bind="explorerProps" />

    <!-- Account Menu -->
    <AccountMenu />
  </div>
</template>
